<script lang="ts">
import { useStoreTranslations } from '../../../../store/translations/translations';
import Button1XP from '../../../Button1XP/Button1XP.vue';
import type { AccountNavigationItems } from '../../CustomerNavigation1XP.vue';

type Props = {
  items: AccountNavigationItems[];
};
</script>
<script setup lang="ts">
defineProps<Props>();

const storeTranslations = useStoreTranslations();
</script>
<template>
  <nav :class="$style.container" :title="storeTranslations.translations?.['customerNav.title']">
    <ul>
      <li v-for="item in items" :key="item.id">
        <Button1XP
          end-icon="chevron_right"
          :text="item.label"
          :url="item.url"
          variant="linkStatic"
          @click="item.action ? item.action() : undefined"
        />
      </li>
    </ul>
  </nav>
</template>

<style lang="scss" module src="./CustomerNav.scss" />
